import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { getCategories } from '../api/catalog'
import type { Category } from '../api/types'
import Loading from '../components/Loading'

function CategoryNode({ category }: { category: Category }) {
  return (
    <li>
      <Link to={`/urunlerimiz?category=${category.id}`}>{category.title}</Link>
      {category.children.length > 0 && (
        <ul>
          {category.children.map((child) => (
            <CategoryNode key={child.id} category={child} />
          ))}
        </ul>
      )}
    </li>
  )
}

export default function CategoryPage() {
  const [categories, setCategories] = useState<Category[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getCategories()
      .then((res) => setCategories(res.categories))
      .catch((err: Error) => setError(err.message))
  }, [])

  if (error) return <p className="error container section">{error}</p>
  if (!categories) return <Loading />

  return (
    <div className="container section">
      <Helmet>
        <title>Kategoriler | Helmach</title>
      </Helmet>

      <div className="section-heading">
        <h1>Kategoriler</h1>
      </div>
      <ul className="category-tree">
        {categories.map((category) => (
          <CategoryNode key={category.id} category={category} />
        ))}
      </ul>
    </div>
  )
}
